/**
 * customMonitor Module
 *
 * Description 资源中心权限分配
 * Author:SMG 2016-6-03
 */
'use strict';
angular
    .module('manageCfg.roleManageMent.permissionAssignment.resourceCenter', ['manageCfg.roleManageMent.permissionAssignment.SavePerModule'])
    .controller('resourceCenterPermission', [
        '$scope',
        '$timeout',
        '$state',
        '$modal',
        'trsHttpService',
        'modalDialog',
        'permissionAssignmentService',
        'globleParamsSet',
        function($scope, $timeout, $state, $modal, trsHttpService, modalDialog, permissionAssignmentService, globleParamsSet) {
            // 声明将要保存权限的数组对象开始
            var selecetedChanls = {};
            // 声明将要保存权限的数组对象结束
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化状态
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.status = {
                    methodDictionary: {
                        资源中心: 'source',
                        个人素材库: 'personalmaterial',
                        已编素材库: 'editedmaterial',
                        共享素材库: 'sharedmaterial',
                        媒资素材库: 'mzmaterial',
                    },
                };
            }
            $scope.productAndModule = function() {
                $modal.open({
                    templateUrl: './manageConfig/roleManageMent/permissionAssignment/service/productAndModule/productAndModule_tpl.html',
                    scope: $scope,
                    windowClass: 'manage-authorityAssignment',
                    backdrop: false,
                    controller: 'productAndModuleCtrl',
                });
            };
            $scope.channelTreeOptions = {
                nodeChildren: 'CHILDREN',
                injectClasses: {
                    ul: 'a1',
                    li: 'manage-main-rightDiv-leftDiv-treeLi',
                    liSelected: 'a7',
                    iExpanded: 'a3', // "manage-main-rightDiv-leftDiv-treeIcon",
                    iCollapsed: 'a4', // "manage-main-rightDiv-leftDiv-treeIcon",
                    iLeaf: 'a5',
                    label: 'a6',
                    labelSelected: 'a8',
                },
                dirSelectable: true,
                allowDeselect: false,
            };

            /**
             * [isAuthorized description] 判断是否已赋权，渲染左侧树节点
             * @param   {[type]}  node  [node description]
             * @return  {[type]}        [return description]
             */
            $scope.isAuthorized = function(node) {
                var flag = false;
                if (angular.isDefined(node.RIGHTINDEX)) {
                    var rightIndexs = node.RIGHTINDEX.split(',');
                    for (var i = 0; i < rightIndexs.length; i++) {
                        if (node.RIGHTVALUE[parseInt(rightIndexs[i].replace(/\"/g, '')) - 1] === '1') {
                            flag = true;
                        }
                    }
                }
                return flag;
            };

            /**
             * [cTshowSelected description] 选择节点
             * @param   {[type]}  sel  [sel description]
             * @return  {[type]}       [return description]
             */
            $scope.cTshowSelected = function(sel) {
                permissionAssignmentService.initGroupRight(sel, $scope.roleData.ROLEID).then(function(data) {
                    sel.RIGHTID = data;
                    delete $scope.rightClassify;
                    $scope.authorSelectedNode = sel;
                    if (!angular.isArray($scope.authorSelectedNode.RIGHTVALUE)) {
                        $scope.authorSelectedNode.RIGHTVALUE = $scope.authorSelectedNode.RIGHTVALUE.split('');
                        $scope.authorSelectedNode.HASSED = $scope.authorSelectedNode.RIGHTVALUE.indexOf('1') > -1;
                    }
                    // 将要推送的保存权限对象开始
                    var tempId = $scope.authorSelectedNode.OBJID;
                    var tempObj = {
                        ID: parseInt($scope.authorSelectedNode.RIGHTID),
                        OPRTYPE: 203,
                        OPRID: parseInt($scope.roleData.ROLEID),
                        OBJTYPE: parseInt($scope.authorSelectedNode.OBJTYPE),
                        OBJID: parseInt($scope.authorSelectedNode.OBJID),
                        NEWVALUE: $scope.authorSelectedNode.RIGHTVALUE,
                    };

                    selecetedChanls[tempId] = tempObj;
                    // 将要推送的保存权限对象结束
                    queryRightClassify();
                });
            };
            // 处理节点名称，用于应对不同模块类型节点名称显示
            $scope.getNodeDesc = function(node) {
                return node.MODALNAME;
            };
            // 保存权限开始
            $scope.save = function() {
                var i = 0,
                    postRights = [];
                for (var key in selecetedChanls) {
                    postRights.push(angular.copy(selecetedChanls[key]));
                    postRights[i].NEWVALUE = angular.isArray(postRights[i].NEWVALUE) ? postRights[i].NEWVALUE.join('') : postRights[i].NEWVALUE;
                    i++;
                }
                var postRightsString = JSON.stringify(postRights);

                /* if ($scope.classify !== "iwo") {
                    selecetedChanls = {};
                }*/
                var params = {
                    serviceid: 'mlf_extrole',
                    methodname: 'saveRight',
                    RoleId: $scope.roleData.ROLEID,
                    rights: postRightsString,
                };
                if (postRights.length === 0) {
                    modalDialog.alertType('您未设置过权限', '', 'info', false);
                    return;
                }
                $scope.loadingPromise = trsHttpService.httpServer('/wcm/mlfcenter.do', params, 'post').then(function(data) {
                    modalDialog.alertType('保存权限成功', '', 'success', false);
                });
            };
            // 保存权限结束
            /**
             * [getChannelTree description] 获取树开始
             * @param   {[type]}  roleId    [roleId description]
             * @param   {[type]}  callback  [callback description]
             * @return  {[type]}            [return description]
             */
            function getChannelTree(roleId, callback) {
                var params = {
                    serviceid: 'mlf_extrole',
                    methodname: 'queryResourceMediaProduct',
                    RoleId: $scope.roleData.ROLEID,
                    modalname: $state.params.type,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    $scope.channelTree = [data];
                    if (angular.isFunction(callback)) {
                        callback(data);
                    }
                });
            }

            /**
             * [queryRightClassify description] 获取权限列表
             * @return  {[type]}            [return description]
             */
            function queryRightClassify() {
                globleParamsSet.queryRightClassify($scope.status.methodDictionary[$state.params.type]).then((data) => {
                    $scope.rightClassify = data;
                    $scope.initSelectAll();
                });
            }

            // 初始化全选按钮方法开始
            $scope.initSelectAll = function() {
                $scope.rightClassify.selectAll = true;
                for (var i = 0; i < $scope.rightClassify.CHILDREN.length; i++) {
                    $scope.rightClassify.CHILDREN[i].selectAll = true;
                    for (var j = 0; j < $scope.rightClassify.CHILDREN[i].CHILDREN.length; j++) {
                        if (
                            $scope.authorSelectedNode.RIGHTVALUE.length === 0 ||
                            $scope.authorSelectedNode.RIGHTVALUE[$scope.rightClassify.CHILDREN[i].CHILDREN[j].RIGHTINDEX - 1] === '0'
                        ) {
                            $scope.rightClassify.CHILDREN[i].selectAll = false;
                        }
                    }
                    if ($scope.rightClassify.CHILDREN[i].selectAll === false) {
                        $scope.rightClassify.selectAll = false;
                    }
                }
            };
            // 初始化全选按钮方法结束
            /**
             * [initData description] 初始化数据
             * @return  {[type]}  [return description]
             */
            function initData() {
                $scope.hideLeft = true; // 隐藏掉左侧树；
                // 获取左侧树开始
                getChannelTree($scope.roleData.ROLEID, function(data) {
                    $scope.cTshowSelected($scope.channelTree[0]);
                    $scope.perSelectedNode = $scope.channelTree[0];
                });
                // 获取左侧树结束
                // 获取从产品列表得到的产品数据开始
                getProductListData();
                // 获取从产品列表得到的产品数据结束
                if ($scope.roleData === undefined) {
                    modalDialog.alertType('请先选择角色', '', 'info', false);
                    $state.go('manageconfig.rolemanage');
                }
                // 监控角色切换开始
                $scope.$on('roleData', function(event, data) {
                    $scope.roleData = data;
                    getChannelTree($scope.roleData.ROLEID, function(data) {
                        $scope.cTshowSelected($scope.channelTree[0]);
                        $scope.perSelectedNode = $scope.channelTree[0];
                    });
                    delete $scope.rightClassify;
                });
                // 监控角色切换结束
                // 模板名称字数限制开始
                $scope.tempNameNum = 6;
                // 模板名称字数限制结束
            }

            /**
             * [getProductListData description]
             * @return  {[type]}  [return description]
             */
            function getProductListData() {
                $scope.moduleName = '资源中心';
                // $scope.classify = 'source';
            }
            // 获取从产品列表得到产品数据结束

            /**
             * [SavePermissions description] 保存为模板
             * @return  {[type]}  [return description]
             */
            $scope.SavePermissions = function() {
                $modal.open({
                    templateUrl: './manageConfig/roleManageMent/permissionAssignment/service/SavePerModule/SavePerModule.html',
                    scope: $scope,
                    windowClass: 'manageSavePerTemp',
                    backdrop: false,
                    controller: 'SavePerModuleController',
                });
            };

            /**
             * [selectTemplateFn description] 选择模板
             * @return {[type]} [description]
             */
            $scope.selectTemplateFn = function() {
                $timeout(function() {
                    if (!angular.isArray($scope.selectTemplate.NEWVALUE) && $scope.selectTemplate.NEWVALUE !== undefined) {
                        $scope.authorSelectedNode.RIGHTVALUE = $scope.selectTemplate.NEWVALUE.split('');
                        $scope.authorSelectedNode.HASSED = $scope.authorSelectedNode.RIGHTVALUE.indexOf('1') > -1;
                        var tempObj = {
                            ID: parseInt($scope.authorSelectedNode.RIGHTID),
                            OPRTYPE: 203,
                            OPRID: parseInt($scope.roleData.ROLEID),
                            OBJTYPE: parseInt($scope.authorSelectedNode.OBJTYPE),
                            OBJID: parseInt($scope.authorSelectedNode.OBJID),
                            NEWVALUE: $scope.authorSelectedNode.RIGHTVALUE,
                        };
                        selecetedChanls[$scope.authorSelectedNode.OBJID] = tempObj;
                        // 全选按钮初始化开始
                        $scope.initSelectAll();
                        // 全选按钮初始化结束
                    }
                });
            };
        },
    ]);
